import { render } from "./Compliance.vue?vue&type=template&id=207dda0c&scoped=true"
import script from "./Compliance.vue?vue&type=script&lang=js"
export * from "./Compliance.vue?vue&type=script&lang=js"

import "./Compliance.vue?vue&type=style&index=0&id=207dda0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-207dda0c"]])

export default __exports__